// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"237":"component---src-pages-assets-js","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"223":"92e80a57720d13d69298","237":"432aaece0cda3499bc85","678":"7a62220584f1afde8501","843":"d0b34008dc21f9c6088d","883":"346f79eef939570ce89f"}[chunkId] + ".js";
};